import { readStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';

export const activeReports = (entity) => ({
  open: false,
  entity,
  category: null,
  code: null,
  name: null,
  reportType: null,
});

export const activeReport = (entity) => ({
  open: false,
  entity,
  category: null,
  code: null,
  name: null,
  reportType: null,
  reportId: null,
});

export const dictionaryReportsState = () => ({
  entity: 'dictionary',
  code: null,
  name: null,
  validation: {
    ...readStates,
    items: [],
  },
  conversion: {
    ...readStates,
    items: [],
  },
});

export const dictionaryReportsDownloadState = () => ({
  entity: 'dictionary',
  code: null,
  name: null,
  validation: {
    items: [],
  },
  conversion: {
    items: [],
  },
});

export const reportDownloadState = () => ({
  ...readStates,
  reportId: null,
  data: null,
});

export const dataModelReportsDownloadState = () => ({
  entity: 'datamodel',
  code: null,
  name: null,
  items: [],
});

const initialState = {
  dataModelReports: {
    open: {
      results: [],
    },
    downloads: {
      results: [],
    },
  },
  dataModelReportsDialog: activeReports('datamodel'),
  dictionaryReports: {
    open: {
      results: [],
    },
    downloads: {
      results: [],
    },
  },
  dictionaryReportDialog: activeReport('dictionary'),
  dictionaryReportsDialog: activeReports('dictionary'),
};

export const findDictionaryReport = ({ dictionaryReports }, { category, code }) => (
  findResult(dictionaryReports, category, code)
);

export const findDataModelReport = ({ dataModelReports }, { category, code }) => (
  findResult(dataModelReports, category, code)
);

export default initialState;
